import { z } from 'zod';

// Real-world facts the game shows, kept by the super admin (checked against GOV.UK when changed). The game's
// own elections come later; until then the Prime Minister shown is the real one.
export const WorldFacts = z
  .object({
    primeMinister: z
      .object({
        name: z.string().trim().min(2).max(60),
        since: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Use a date like 2026-07-20'),
      })
      .strict(),
  })
  .strict();
export type WorldFacts = z.infer<typeof WorldFacts>;
// from GOV.UK, checked 9 October 2026: Andy Burnham became Prime Minister on 20 July 2026
export const DEFAULT_WORLD_FACTS: WorldFacts = { primeMinister: { name: 'Andy Burnham', since: '2026-07-20' } };
export const WorldFactsReply = z.object({ world: WorldFacts });
export type WorldFactsReply = z.infer<typeof WorldFactsReply>;

// deleting an account: the player types their @username to confirm
export const AccountDelete = z.object({ confirmUsername: z.string().trim().min(1).max(40) }).strict();
export type AccountDelete = z.infer<typeof AccountDelete>;

// How long an admin may be idle before the dashboard signs them out, chosen by the super admin (every change
// audited). The server enforces it on every request; a session also ends after its longest life, however busy.
export const ADMIN_IDLE_CHOICES = [15, 30, 60, 120, 240, 480, 720] as const;
export const AdminSessionSettings = z
  .object({
    idleMinutes: z
      .number()
      .int()
      .refine((value) => (ADMIN_IDLE_CHOICES as readonly number[]).includes(value), 'Pick one of the choices'),
  })
  .strict();
export type AdminSessionSettings = z.infer<typeof AdminSessionSettings>;
export const AdminSessionSettingsReply = z.object({
  settings: AdminSessionSettings,
  // the longest an admin session lasts, whatever the idle time
  sessionHours: z.number().int(),
});
export type AdminSessionSettingsReply = z.infer<typeof AdminSessionSettingsReply>;
